<div class="whatsapp-template">
  <div class="selectable" *ngIf="true">
    <ng-content></ng-content>
  </div>
  <div class="content">
    <div [attr.data-testid]="'template-name'" class="template-name">{{ template.name }}</div>
    <div [attr.data-testid]="'template-text'" class="template-text">
      {{ template.textWithReplacedPlaceholders }}
    </div>
    <div>
      <button
        mat-stroked-button
        *ngFor="let button of template.buttons; index as j"
        [attr.data-testid]="'template-button-' + j"
        class="template-button">
        <span *ngIf="button?.type === WhatsappTemplateButtonTypeEnum.COPY_CODE; else buttonText">{{
          'task/whatsapp-template/footer/copy-code-button/label' | translate
        }}</span>
        <ng-template #buttonText>
          <span>{{ button?.text }}</span>
        </ng-template>
      </button>
    </div>
  </div>
</div>
